<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="140px" inline>
          <el-row :gutter="24" type="flex" justify="space-around">
            <el-col :span="10">
              <el-form-item label="平台产品SKU：" align="left">
                <el-input
                  size="small"
                  style="width: 260px"
                  v-model="queryParams.order"
                  placeholder="多个订单编号用英文逗号隔开"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="设计编号：" align="left">
                <el-input size="small" style="width: 260px" v-model="queryParams.number" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="text-align: right">
              <el-form-item style="text-align: right">
                <el-button size="small" type="primary">搜索</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
      <el-table
        v-loading="loading"
        :data="tableData"
        border
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="品台产品" width="400">
          <template slot-scope="scope">
            <el-row :gutter="24">
              <el-col :span="4">
                <div>
                  <img width="60" height="80" :src="scope.row.product.imgUrl" alt="" />
                </div>
              </el-col>
              <el-col :span="20">
                <div style="height: 40px">
                  Mouse Pad Computer,Laptop,Gaming
                </div>
                <div>
                  nichdy-#Z2Er4Kp3MSrM49S-mosp
                </div>
                <div>
                  <span style="display: inline-block; margin-right: 10px">颜色：黑色</span> <span>尺码： L</span>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="定制产品" width="400">
          <template slot-scope="scope">
            <el-row :gutter="24">
              <el-col :span="4">
                <div>
                  <img width="60" height="80" :src="scope.row.product.imgUrl" alt="" />
                </div>
              </el-col>
              <el-col :span="20">
                <div style="height: 40px">
                  <el-button type="text">
                    仿羊绒流苏围巾（竖）
                  </el-button>
                </div>
                <div>
                  设计编号：234234234
                </div>
                <div>
                  <span style="display: inline-block; margin-right: 10px">颜色：黑色</span> <span>尺码： L</span>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operator"></el-table-column>
        <el-table-column label="关联时间" prop="ctime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDeleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pageSize: 30,
        pageNum: 1,
      },
      importFileVisible: false,
      fileForm: {},
      total: 0,
      loading: false,
      tableData: [
        {
          product: {
            imgUrl:
              'https://nimg5.hicustom.com/static/productDet/XE45E3-1-29-1-1000-41eaca048ef564007f462d641f1f191b.jpg',
          },
          relatedProduct: {
            imgUrl:
              'https://nimg5.hicustom.com/static/productDet/XE45E3-1-29-1-1000-41eaca048ef564007f462d641f1f191b.jpg',
          },
          ctime: '2021-04-10 23:22:21',
          operator: 'xxx',
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /* 获取列表数据 */
    loadData() {
      this.total = 1;
    },
    /* 下载数据 */
    handleDownload(row) {},
    /* 删除 */
    handleDeleteItem(row) {
      this.$confirm
        .confirm('是否确认删除产品关联？删除后，再次导入此产品需要重新关联', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        .then(() => {})
        .then(() => {
          this.msgSuccess('删除成功');
          this.loadData();
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
